const errors = {
  missing: 'is required',
  invalid: 'is invalid',
  invalidMaxLength: 'too long',
  alreadyExists: 'already exists',
  alreadyRemoved: 'already removed',
}

export default errors